exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-file .el-button[data-v-5f40a573]{width:100%;height:36px}.sperate-line[data-v-5f40a573]{margin:10px 0;height:1px;background-color:#e8e8e8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f40a573&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/Components/HardwareConfig.vue
// module id = 548
// module chunks = 0